import {
  DEFAULT_SHOPPING_CART,
  IShoppingCart,
  SHOPPING_CART_SCHEMA,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IGetGateway, ISaveGateway } from '../gateways';

export class ShoppingCartGateway
  implements
    IGetGateway<string, IApiResponse<IShoppingCart>>,
    ISaveGateway<IShoppingCart, IApiResponse<IShoppingCart>>
{
  private readonly restCallBuilder: RestCallBuilder<IShoppingCart> =
    new RestCallBuilder<IShoppingCart>(DEFAULT_SHOPPING_CART);

  get(): Observable<IApiResponse<IShoppingCart>> {
    return this.restCallBuilder
      .get('/shoppingCart/')
      .validate(API_RESPONSE_SCHEMA(SHOPPING_CART_SCHEMA), 'ShoppingCart.get')
      .handleMessages()
      .build();
  }

  save(query: IShoppingCart): Observable<IApiResponse<IShoppingCart>> {
    return this.restCallBuilder
      .post('/shoppingCart/', query)
      .validate(API_RESPONSE_SCHEMA(SHOPPING_CART_SCHEMA), 'ShoppingCart.save')
      .handleMessages()
      .build();
  }
}
